import { atom, selector } from "recoil";
import { HIMAWARI_AREA_JP, HIMAWARI_TYPE_IRHT_COLOR } from "../components/map/layers/Himawari";
import { getCustomerSettings } from "../CustomerSettings";

export const himawariTypeState = atom({
  key: 'himawariTypeState',
  default: selector({
    key: 'himawariTypes',
    get: () => {
      const areaType = getCustomerSettings("layerConfig.WX_ID_HIMAWARI.defaultArea");
      const dataType = getCustomerSettings("layerConfig.WX_ID_HIMAWARI.defaultData");
      return {
        areaType: areaType ? areaType : HIMAWARI_AREA_JP,
        dataType: dataType ? dataType : HIMAWARI_TYPE_IRHT_COLOR
      };
    }
  })
});
